module.exports = __webpack_public_path__ + "img/logo_GLF-colour.4283db04.svg";